<template>
    <dropdown class="mr-8 md:mr-0" placement="bottom-end" :auto-close="false">
        <template #default>
            <span class="cursor-pointer relative">
                <font-awesome-icon icon="fa-regular fa-comment" size="2xl" class="text-blue-500" :class="'group-hover:text-white'" />
                <span class="text-white bg-red-600 rounded-full text-center w-5 text-[10px] absolute -right-1/4 -bottom-2">{{ unreadMessages }}</span>
            </span>
        </template>
        <template #dropdown>
            <div class="mt-2 bg-white rounded shadow-xl">
                <chat :roomsUnreadMessages="roomsUnreadMessages" />
            </div>
        </template>
    </dropdown>
</template>
<script>
import fire from "./fire";
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import Dropdown from '@/Shared/Dropdown'
import Chat from './Chat'

export default {
  data() {
    return {
      unreadMessages: 0,
      roomsUnreadMessages: {}
    }
  },
  components: {
    Dropdown,
    Chat,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  mounted() {
    fire.database().ref('user_room_messages_read/' + this.user.id).on("value", this.loadUnreadMessages);
  },
  methods: {
    loadUnreadMessages(unreadMessages) {
      this.roomsUnreadMessages = {};
        let _unreadMessages = 0;
        unreadMessages.forEach((_unreadMessage) => {
            let unreadMessageKey = _unreadMessage.key;
            let unreadMessage = _unreadMessage.val();
            let roomsUnreadMessage = Object.keys(unreadMessage).length;
            _unreadMessages += roomsUnreadMessage;
            //this.roomsUnreadMessages[unreadMessageKey] = roomsUnreadMessage;
            this.roomsUnreadMessages[unreadMessageKey] = Object.keys(unreadMessage);
        });
        this.unreadMessages = _unreadMessages;
    }
  },
}
</script>